module.exports = __webpack_public_path__ + "static/media/KargoMX-Logo.993d962a.png";